import React from "react";
import styles from "./OrderStatusApp.module.scss";
import ShopStylingWrapper from "../ShopStylingWrapper";

function OrderStatusApp(props) {
    const { Page, sharedAppProps } = props;

    return (
        <ShopStylingWrapper {...props} appProps={sharedAppProps}>
            <div className={styles["app-container"]}>
                <Page {...props} appProps={sharedAppProps} />
            </div>
        </ShopStylingWrapper>
    );
}

export default OrderStatusApp;
